<template>
  <XField
    :errors="validationErrors(formattedLabel)"
    :errorStyle="formFieldsErrorStyle">
    <XInput
      color="secondary"
      :type="getInputType"
      :label="label"
      :labelStyle="labelStyle"
      :inputStyle="validationHasErrors(formattedLabel) ? inputCustomStyles: {}"
      :data-vv-name="formattedLabel"
      :invalid="validationHasErrors(formattedLabel)"
      :optional="isOptional"
      v-model="fieldValue"
      v-validate="validationRules"
      @blur="validate" />
  </XField>
</template>

<script>
import _ from 'lodash'

import InputMixin from './InputMixin'

export default {
  mixins: [InputMixin],

  computed: {
    validationRules () {
      let validationRules = {
        required: this.parameters.required
      }

      if (this.parameters.type === 'phone') {
        validationRules['min'] = 6
      }

      if (
        this.parameters.type === 'firstName' ||
        this.parameters.type === 'lastName' ||
        this.parameters.type === 'secondLastName' ||
        this.parameters.type === 'postalCode'
      ) {
        validationRules['min'] = 2
      }

      return validationRules
    },

    formattedLabel () {
      return this.parameters.type === 'custom'
        ? _.lowerCase(this.parameters.config.label)
        : this.parameters.type
    },

    label () {
      return this.parameters.type === 'custom'
        ? this.parameters.config.label
        : this.$t('common.formFields.' + this.parameters.type)
    },

    getInputType () {
      return this.parameters.type === 'phone' ? 'tel' : 'text'
    }
  },

  methods: {
    validate () {
      this.$validator.validate(this.formattedLabel)
    }
  }
}
</script>
